import { useEffect } from 'react';

/**
 * Script que detecta mudanças de phase e envia mensagens mapeadas
 * Suporta wildcard "*" para transições genéricas
 * Exemplo: 'SelfIntroductionsA -> *': { content: 'Well done!', showTo: 'A' }
 */

let lastPhase = null;

// Mapa de transições e mensagens correspondentes
const transitionMessages = {
  'SELF_INTRODUCTIONS_A -> *': { content: 'Well done!', showTo: 'A' },
  'SELF_INTRODUCTIONS_B -> *': { content: 'Well done!', showTo: 'B' },
  // Adicione mais transições aqui conforme necessário
};

export function startManualMessageScript(insertManualMessage, currentPhase) {
  // Detecta mudança de fase
  if (currentPhase !== lastPhase) {
    // Verifica se há uma mensagem mapeada para esta transição
    const transitionKey = `${lastPhase} -> ${currentPhase}`;
    const wildcardKey = `${lastPhase} -> *`;

    let message = null;

    // Primeiro tenta a transição exata
    if (transitionMessages[transitionKey]) {
      message = transitionMessages[transitionKey];
    }
    // Depois tenta com wildcard
    else if (transitionMessages[wildcardKey]) {
      message = transitionMessages[wildcardKey];
    }

    // Se encontrou uma mensagem mapeada, envia ela
    if (message) {
      insertManualMessage(message.content, 2000, message.showTo);
    }

    // Atualiza o histórico
    lastPhase = currentPhase;
  }
}

// Hook para usar o script facilmente
export function useManualMessageScript(insertManualMessage, currentPhase) {
  useEffect(() => {
    if (!insertManualMessage) {
      return;
    }

    startManualMessageScript(insertManualMessage, currentPhase);
  }, [insertManualMessage, currentPhase]);
}
